module.exports = __webpack_public_path__ + "static/screen2-8ddad06816c6efe48077786134104f04.png";